import InfoBlackIcon from "../../public/icon/info-black.svg";
import Button from "../UI/Button";
import { Tooltip } from "../UI/Tooltip";
import classnames from "classnames";
import { useTranslation } from "next-i18next";
import { INft } from "../../constants/nft-auth";
import _Popover from "@mui/material/Popover";
import { useEffect, useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { CollectionTypes } from "../../constants/collection";

interface IProps {
  nft: INft;
  onAuth(nft): void;
  onDeauth(nft): void;
  onChangeUid(nft): void;
}

const theme = createTheme({
  components: {
    MuiPopover: {
      styleOverrides: {
        paper: {
          borderRadius: 40,
          overflow: "hidden",
        },
      },
    },
  },
});

export const Popover = (props) => (
  <ThemeProvider theme={theme}>
    <_Popover {...props} />
  </ThemeProvider>
);

const DeauthorizeBtn = ({ nftauthT, nft, onDeauth }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement>();

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <button
        className="h-full w-[120px] btn-unstyled rounded-full flex justify-center items-center align-middle text-[14px] transition border border-black border-solid hover:text-[#ff2800] hover:border-[#ff2800] font-medium"
        onClick={(event) => {
          setAnchorEl(event.currentTarget);
        }}
      >
        {nftauthT("t3")}
      </button>
      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        transformOrigin={{
          vertical: -48,
          horizontal: 120,
        }}
      >
        <div className="w-[360px] p-[32px] pt-[40px] rounded-[40px] bg-white shadow-[0_4px_8px_rgba(0,0,0,0.2)]">
          <div className="text-[14px] font-light leading-[21px] text-center whitespace-pre-wrap mb-[20px] ">
            {nftauthT("t14")}
          </div>
          <div className="h-[40px] flex justify-center">
            <button
              className="h-full w-[140px] btn-unstyled rounded-full flex justify-center items-center align-middle text-[14px] transition border border-black border-solid hover:text-[#ff2800] hover:border-[#ff2800]"
              onClick={() => {
                setAnchorEl(null);
              }}
            >
              {nftauthT("t15")}
            </button>
            <Button
              variant="contained"
              color="secondary"
              component="span"
              className={classnames(
                "w-[140px] h-full rounded-full transition font-medium text-[14px] ml-[16px]",
                "text-white hover:opacity-80"
              )}
              onClick={() => {
                setAnchorEl(null);
                onDeauth();
              }}
            >
              <span>{nftauthT("t16")}</span>
            </Button>
          </div>
        </div>
      </Popover>
    </>
  );
};

export function NFTItem({ nft, onAuth, onDeauth, onChangeUid }: IProps) {
  const { t: nftauthT } = useTranslation("nftauth");

  const tips =
    nft.contractType === CollectionTypes.cheersUpEmoji
      ? nftauthT("t28")
      : nftauthT("t1");

  return (
    <div
      className="bg-[#F1F2F3] rounded-[24px] mb-[24px] p-[16px] pr-[24px] odd:mr-[24px] flex items-center"
      style={{ width: "calc((100% - 24px) / 2)" }}
    >
      <div className="w-[120px] min-w-[120px] h-[120px] rounded-[16px] mr-[12px] overflow-hidden bg-white">
        <nft-viewer type="image" src={nft.image}></nft-viewer>
      </div>
      <div className="flex-1">
        <div className="flex justify-between items-center mb-[8px]">
          <div
            className="flex-1 text-[20px] font-black leading-[23px] line-clamp-1"
            title={nft.name}
          >
            {nft.name}
          </div>
          {nft.bindUids.length > 0 && (
            <Tooltip
              arrow
              placement="top"
              title={<div className="whitespace-pre-wrap">{tips}</div>}
            >
              <button className="btn-unstyled text-[#9499A0] text-[12px] font-light flex items-center ml-[8px]">
                <InfoBlackIcon className="h-[12px] w-[12px]" />
                <span className="ml-[6px]">{nftauthT("t27")}</span>
              </button>
            </Tooltip>
          )}
        </div>

        {nft.bindUids.length > 0 ? (
          <div className="flex items-center">
            <div className="mr-[8px] px-[6px] h-[18px] flex justify-center items-center bg-[#9499A0] rounded-[6px] text-[12px] text-white">
              {nftauthT("t2")}
            </div>
            <div className="text-[12px] font-light">
              bilibili UID: {nft.bindUids.join(", ")}
            </div>
          </div>
        ) : (
          <div className="text-[12px] font-light">by {nft.issuer}</div>
        )}
        <div className="mt-[24px]  h-[34px] flex justify-end items-center">
          {nft.bindUids.length > 0 ? (
            <>
              <DeauthorizeBtn
                nft={nft}
                nftauthT={nftauthT}
                onDeauth={() => {
                  onDeauth(nft);
                }}
              />
              <Button
                variant="contained"
                color="secondary"
                component="span"
                className={classnames(
                  "w-[120px] h-full rounded-full transition font-medium text-[14px] ml-[16px]",
                  "text-white hover:opacity-80"
                )}
                onClick={() => {
                  onChangeUid(nft);
                }}
              >
                <span>{nftauthT("t4")}</span>
              </Button>
            </>
          ) : (
            <Button
              variant="contained"
              color="secondary"
              component="span"
              className={classnames(
                "w-[120px] h-full rounded-full transition font-medium text-[14px] ml-[16px]",
                "text-white hover:opacity-80"
              )}
              onClick={() => {
                onAuth(nft);
              }}
            >
              <span>{nftauthT("t5")}</span>
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
